<template>

    <CRow>
        <CCol>
            <CCard class="store-card">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow class="pl-3 pb-3" />
                    
                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.title }}</CCol>
                    </CRow>
                    <CRow
                        v-if="entity.why_is_it_off" 
                        form
                        class="form-group"
                        style="color: red; font-weight: 600">
                        <CCol sm="3" class="col-form-label">Последнее отключение:</CCol>
                        <CCol sm="9" class="col-form-label">
                            Причина: {{ entity.why_is_it_off }}
                            <br /> Кто отключил: {{ entity.who_turned_off }}
                            <br /> Дата отключения: {{ entity.shutdown_date }}
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Код</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.code }}</CCol>
                    </CRow>
                    <CRow
                        v-if="entity.partner"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Партнер</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CLink v-if="adminOnly" :to="`/partners/${entity.partner.id}`">{{ entity.partner.title }}</CLink>
                            <template v-else>{{ entity.partner.title }}</template>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Короткое название</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.short_name }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Юр. лицо</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.legal_entity }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Алиас</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.alias }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Башня</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.towerObj ? entity.towerObj.name : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Зона</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.towerObj && entity.towerObj.zone ? entity.towerObj.zone.name : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Краткое описание</CCol>
                        <CCol sm="9" class="col-form-label" v-html="entity.description"></CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка сервиса (мобильное приложение)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка поиска</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="squarePictureUrl"
                                class="m2"
                                width="150" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для десктопа (внутри сервиса)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="desktopPictureUrl"
                                class="m2"
                                width="150" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для десктопа (список)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="desktopPictureUrlInList"
                                class="m2"
                                width="150" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для популярного</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="popularPictureUrl"
                                class="m2"
                                width="150" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для описания</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="descriptionPictureUrl"
                                class="m2"
                                width="150" />
                        </CCol>
                    </CRow>                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Размер плитки товаров</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.small_cards ? 'Мелкая' : 'Крупная' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Страница категорий</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.categories_page ? 'Включена' : 'Отключена' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показывать изображения для описания</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.show_description_picture ? 'Включена' : 'Отключена' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Открывается в</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.open_at }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Закрывается в</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.close_at }}</CCol>
                    </CRow>
                    <!-- <Schedule :schedule="schedule" /> -->
                    <WorkingHours 
                        v-if="entity.entityType"
                        :working-hours="workingHours"
                        :service-type="entity.entityType.code"
                    />

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Минимальный заказ</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.min_price ? entity.min_price : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Минимальная сумма для самовывоза</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.min_price_pickup ? entity.min_price_pickup : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Телефон</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.phone }}</CCol>
                    </CRow>
                    <CRow
                        v-if="entity.delivery_time_hour"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Время, необходимое на выполнение заказа (часы)</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.delay_time_hour }}</CCol>
                    </CRow>
                    <CRow
                        v-if="entity.delivery_time"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Время, необходимое на выполнение заказа (минуты)</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.delay_time }}</CCol>
                    </CRow>
                    <CRow
                        v-if="entity.delivery_time_hour"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Время доставки (часы)</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.delivery_time_hour }}</CCol>
                    </CRow>
                    <CRow
                        v-if="entity.delivery_time"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Время доставки (минуты)</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.delivery_time }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Лейбл</CCol>
                        <CCol sm="9" class="col-form-label">{{ labelType(entity.service_label) }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Кнопка "В корзину", текст</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.cart_button_title || '—' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Кнопка "В корзину", ссылка</CCol>
                        <CCol sm="9" class="col-form-label">{{ entity.cart_button_link || '—' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Калории за 100 г</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(entity.calories_100g)">
                                &nbsp;{{ entity.calories_100g ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Рекламный партнер</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(entity.is_advertisement)">
                                &nbsp;{{ entity.is_advertisement ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Не показывать закрытым</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(entity.not_close_service)">
                                &nbsp;{{ entity.not_close_service ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Убрать применение промокода</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(entity.hide_promocode)">
                                &nbsp;{{ entity.hide_promocode ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Отключить применение тарифов по зонам</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(entity.delivery_zone_disabled)">
                                &nbsp;{{ entity.delivery_zone_disabled ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(entity.enabled)">
                                &nbsp;{{ entity.enabled ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="stopModal = true">Стоп</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <StopServiceModal
            :id="+$route.params.id"
            :open="stopModal"
            :type="BUSINESS_TYPE.ENTITY"
            @stop-modal-close="stopModal = false"
            @stop-modal-update="setSchedule"
        />

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    // import Schedule from '@/components/Schedule';
    import WorkingHours from '@/components/WorkingHours';
    import StopServiceModal from '@/components/StopServiceModal';
    import { BUSINESS_TYPE } from '@/utils/order';
    import { BUSINESS_LABEL } from '@/utils/servicesLabel';

    export default {

        name: 'Entity',

        components: {
            EntityTabLinks,
            // Schedule,
            StopServiceModal,
            WorkingHours
        },
  
        data () {
            return {
                schedule: undefined,
                workingHours: [],
                entity: {
                    service_label: '',
                    code: '',
                    title: '',
                    short_name: '',
                    legal_entity: '',
                    alias: '',
                    description: '',
                    picture: '',
                    square_picture: '',
                    desktop_picture: '',
                    desktop_picture_list: '',
                    popular_picture: '',
                    description_picture: '',
                    open_at: '',
                    close_at: '',
                    min_price: 0,
                    phone: '',
                    towerObj: {
                        name: '',
                    },
                    delay_time: 0,
                    delay_time_hour: 0,
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    enabled: true,
                    position: 0
                },
                stopModal: false,
                BUSINESS_TYPE,
                adminOnly: false
            }
        },
    
        computed: {
            pictureUrl() {
                if(this.entity.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.picture;
                } else {
                    return '';
                }
            },
            squarePictureUrl() {
                if(this.entity.square_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.square_picture;
                } else {
                    return '';
                }
            },
            desktopPictureUrl() {
                if(this.entity.desktop_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.desktop_picture;
                } else {
                    return '';
                }
            },
            desktopPictureUrlInList() {
                if(this.entity.desktop_picture_list) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.desktop_picture_list;
                } else {
                    return '';
                }
            },
            popularPictureUrl() {
                if (this.entity.popular_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.popular_picture;
                } else {
                    return '';
                }
            },

            descriptionPictureUrl() {
                if (this.entity.description_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.entity.description_picture;
                } else {
                    return '';
                }  
            }
        },

        mounted() {
            this.adminOnly = !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            const id = this.$route.params.id;
            Vue.axios.get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                    if(resp.data.schedule.length != 0){
                        this.schedule = resp.data.schedule;
                    }
                    if (resp.data.workingHours.length != 0) {
                        this.workingHours = resp.data.workingHours;
                    }
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            labelType (label) {
                const labels = [];
                labels.push({ value: BUSINESS_LABEL.IS_NEW, label: 'Новый сервис' });
                labels.push({ value: BUSINESS_LABEL.VEGAN, label: 'Веган' });
                labels.push({ value: BUSINESS_LABEL.VERIFIED_MIRCITY, label: 'Првоерено МИРСИТИ' });

                for (const type of labels) {
                    if(label === type.value){
                        return type.label;
                    }
                }
                return '';
            },
            goBack() {
                this.$router.push({ path: `/entities/${this.$route.params.code}` })
            },
            getBadge (status) {
                return status ? 'success' : 'secondary';
            },
            setSchedule(schedule) {
                if (schedule) {
                    this.schedule = schedule;
                }
            }
        }
    }
</script>
<style scoped lang="scss">

</style>
